
import React from "react";
import { Button } from "@/components/ui/button";
import StepCard from "../StepCard";

interface MethodSelectionProps {
  selectedMethod: "classic" | "yolo";
  onMethodChange: (method: "classic" | "yolo") => void;
  onNext: () => void;
  onPrevious: () => void;
  currentPass: number;
}

const MethodSelection = ({ selectedMethod, onMethodChange, onNext, onPrevious, currentPass }: MethodSelectionProps) => {
  const handleMethodSelect = (method: "classic" | "yolo") => {
    onMethodChange(method);
    onNext();
  };

  return (
    <StepCard
      title=""
      onPrevious={onPrevious}
      showPrevious
    >
      <div className="space-y-6">
        <div className="text-center">
          <h3 className="text-lg font-semibold text-foreground mb-2">Choose Calibration Method</h3>
          <p className="text-muted-foreground text-sm">Select your preferred calibration approach</p>
        </div>
        
        <div className="space-y-3">
          <Button
            onClick={() => handleMethodSelect("classic")}
            variant="outline"
            className="w-full p-6 h-auto bg-surface hover:bg-accent/50 border-border/50 transition-all duration-200"
          >
            <div className="text-center">
              <div className="font-semibold text-lg">Classic Method</div>
            </div>
          </Button>
          
          <Button
            onClick={() => handleMethodSelect("yolo")}
            variant="outline"
            className="w-full p-6 h-auto bg-surface hover:bg-accent/50 border-border/50 transition-all duration-200"
          >
            <div className="text-center">
              <div className="font-semibold text-lg">YOLO Method</div>
            </div>
          </Button>
        </div>
        
        <div className="bg-primary/10 border border-primary/20 rounded-lg p-4">
          <p className="text-sm text-foreground/80 mb-2">
            <strong>YOLO is usually faster.</strong>
          </p>
          <p className="text-sm text-foreground/70">
            You only need to use one method, but it may require multiple passes to fine-tune.
          </p>
        </div>
      </div>
    </StepCard>
  );
};

export default MethodSelection;
